export default function TrustBar() {
  const stats = [
    {
      icon: "ri-stack-line",
      value: "14+",
      label: "Categories",
    },
    {
      icon: "ri-file-list-3-line",
      value: "30+",
      label: "Guides",
    },
    {
      icon: "ri-shield-check-line",
      value: "Verified",
      label: "Resources",
    },
    {
      icon: "ri-calendar-check-line",
      value: "2026",
      label: "Updated",
    },
  ];

  return (
    <section className="py-10 md:py-12 bg-background-50 border-b border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat, idx) => (
              <div key={idx} className="flex items-center gap-3 md:gap-4 justify-center">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${stat.icon} text-lg md:text-xl text-accent-600`}></i>
                </div>
                <div>
                  <p className="text-lg md:text-xl font-heading font-bold text-foreground-900 leading-tight">
                    {stat.value}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}